// This module provides API call methods for Sephora Commerce Utility APIs:
// https://jira.sephora.com/wiki/display/ILLUMINATE/Utility+APIs

let storeLocator = require('./storeLocator');
let getAboutMeReviewQuestions = require('./getAboutMeReviewQuestions');
let getAdvocacyLandingPageContent = require('./getAdvocacyLandingPageContent');
let enrollCampaign = require('./enrollCampaign');
let updatePreviewSettings = require('./updatePreviewSettings');
let getPreviewSettings = require('./getPreviewSettings');
let getCountryList = require('./getCountryList');
let getShippingCountryList = require('./getShippingCountryList');
let getSubscriptionCancelReasons = require('./getSubscriptionCancelReasons');
let getGiftCardBalance = require('./getGiftCardBalance');
let getStateAndCityForZipCode = require('./getStateAndCityForZipCode');
let getStateList = require('./getStateList');
let switchShippingCountry = require('./switchShippingCountry');
let getLocation = require('./getLocation');
let contactUs = require('./contactUs/contactUs');
let resetSessionExpiry = require('./resetSessionExpiry');
let validateAddress = require('./validateAddress');
let isUserEligible = require('./isUserEligible');

let { requestEmailNotificationForOutOfStockSku,
    requestEmailNotificationForComingSoonSku,
    cancelEmailNotificationRequest } = require('./requestEmailNotification');

module.exports = {
    storeLocator,
    getAboutMeReviewQuestions,
    enrollCampaign,
    getAdvocacyLandingPageContent,
    updatePreviewSettings,
    getPreviewSettings,
    getCountryList,
    getShippingCountryList,
    getSubscriptionCancelReasons,
    getGiftCardBalance,
    getStateAndCityForZipCode,
    getStateList,
    switchShippingCountry,
    requestEmailNotificationForOutOfStockSku,
    requestEmailNotificationForComingSoonSku,
    cancelEmailNotificationRequest,
    getLocation,
    contactUs,
    resetSessionExpiry,
    validateAddress,
    isUserEligible
};
